<template>
  <tr>
    <td :colspan="colspan" class="peak-details">
      <div class="peak-details__properties">
        <DecoratorProperty
          bgColor="#fff"
          property="Theoretical Plates"
          class="peak-details__property"
        >
          {{ (peak.plates && peak.plates.toFixed(0)) || 'n/a' }}
        </DecoratorProperty>
        <DecoratorProperty bgColor="#fff" property="Symmetry" class="peak-details__property">
          {{ (peak.asymmetry_at_10_percent && peak.asymmetry_at_10_percent.toFixed(3)) || 'n/a' }}
        </DecoratorProperty>
        <DecoratorProperty bgColor="#fff" property="Fit Quality, R²" class="peak-details__property">
          {{ peakQuality }}
        </DecoratorProperty>
        <DecoratorProperty bgColor="#fff" property="FWHM, min" class="peak-details__property">
          {{ (peak.fwhm && peak.fwhm.toFixed(3)) || 'n/a' }}
        </DecoratorProperty>
        <DecoratorProperty
          bgColor="#fff"
          property="Virtual area, mAU * min"
          class="peak-details__property"
        >
          {{ (peak.virtual_area && peak.virtual_area.toFixed(3)) || 'n/a' }}
        </DecoratorProperty>
        <DecoratorProperty bgColor="#fff" property="Height, mAU" class="peak-details__property">
          {{ (displayHeight && displayHeight.toFixed(3)) || 'n/a' }}
        </DecoratorProperty>
        <DecoratorProperty
          bgColor="#fff"
          property="Noise to signal ratio"
          class="peak-details__property"
        >
          {{ (peak.sn_level && peak.sn_level.toFixed(3)) || 'n/a' }}
        </DecoratorProperty>
      </div>
    </td>
  </tr>
</template>

<script>
  import DecoratorProperty from '@/uikitProject/decorators/DecoratorProperty.vue';

  export default {
    name: 'PeakDetails',

    components: {
      DecoratorProperty,
    },

    props: {
      peak: {
        type: Object,
        required: true,
      },
      colspan: {
        type: Number,
        required: true,
      },
    },

    computed: {
      displayHeight() {
        if (this.peak && this.peak.height != null) return this.peak.height;
        return null;
      },
      peakQuality() {
        if (this.peak.quality_estimation_rsquared && this.peak.quality_estimation_rsquared !== -1) {
          const value = this.peak.quality_estimation_rsquared.toFixed(3);
          return value;
        }
        return 'n/a';
      },
    },
  };
</script>

<style lang="scss" scoped>
  .peak-details {
    padding: 20px 0;
    background-color: white;
    box-shadow: inset 0 10px 5px -10px rgba(0, 0, 0, 0.2),
      inset 0 -10px 5px -10px rgba(0, 0, 0, 0.2);

    @media print {
      padding: 0;
      box-shadow: none;
      background-color: white;
      print-color-adjust: exact;
    }

    &__properties {
      position: sticky;
      left: 32px;
      width: min(100%, 100vw - 64px);
      padding: 12px 0;

      @media print {
        left: 40px;
        padding: 0 0 10px;
        font-size: $size-xxxs;
      }
    }

    &__property:not(:last-child) {
      margin-bottom: 5px;

      @media print {
        margin-bottom: 2px;
      }
    }
  }
</style>
